import React from 'react';
import { motion } from 'framer-motion';
import { FileSearch, Video, Workflow, Scale, Database, Cpu } from 'lucide-react';
const services = [{
  icon: FileSearch,
  title: 'AI Resume Screening',
  description: 'Automatically rank and filter candidates based on your specific criteria.'
}, {
  icon: Video,
  title: 'AI Pre-Screen Interviews',
  description: 'Conduct automated initial interviews to identify top talent 24/7.'
}, {
  icon: Workflow,
  title: 'Workflow Automation',
  description: 'Connect your tools to eliminate manual data entry and status updates.'
}, {
  icon: Scale,
  title: 'Bias Reduction',
  description: 'Standardized evaluation criteria to ensure fair hiring practices.'
}, {
  icon: Database,
  title: 'ATS Integration',
  description: 'Seamlessly integrate AI layers into your existing hiring software.'
}, {
  icon: Cpu,
  title: 'Custom AI Models',
  description: 'Tailored AI solutions built specifically for your unique business needs.'
}];
export function Services() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-89">
      <div className="max-w-7xl mx-auto px-6" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-91">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-92">
            AI Hiring Services for Small Businesses
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-93">
            Comprehensive solutions designed to modernize every stage of your
            recruitment process.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-94">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group p-8 rounded-xl border border-slate-200 bg-white hover:border-blue-200 transition-colors" data-id="element-95">
              <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-100 transition-colors" data-id="element-96">
                <service.icon className="w-6 h-6 text-blue-600" data-id="element-97" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-98">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-99">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}